export const buildTimeOptions = () => {
  const hours = [...Array(24).keys()].map((h) => String(h).padStart(2, '0'));
  const minutes = ['00', '15', '30', '45'];
  return hours.flatMap((hour) => minutes.map((minute) => ({ value: `${hour}:${minute}`, label: `${hour}:${minute}` })));
};
